var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"cards"},_vm._l((_vm.contents),function(v){return _c('card',{key:v.appName,attrs:{"appDescription":v.appDescription,"appName":v.appName,"iconLink":v.iconLink,"color":v.color,"route":v.route}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }